import React from 'react';
import Head from 'next/head';
const MobileView = ({ children }) => {
  return (
    <>
      <Head>
        <link rel="stylesheet" href={'/assets/criticalcss/IBM.css'} />
      </Head>
      {children}
      <style scoped>
        {`
    * {
      font-family: 'IBM Plex Sans Arabic', sans-serif;
    }
    body {
      height: 100%
    }
    `}
      </style>
    </>
  );
};

export default MobileView;
